import React from "react";
import Spinner from '../Spinner';

interface ButtonProps {
  text?: string;
  icon?: React.ReactNode;
  type?: "button" | "submit"
  className?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: (_: any) => void;
  "aria-label"?: string;
}

const Button: React.FC<ButtonProps> = ({
  text, icon, type = "button", className, disabled, loading, onClick, "aria-label": ariaLabel,
}) => {
  return (
    <button
      className={className}
      disabled={disabled || loading}
      type={type}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      {loading ? (
        <Spinner />
      ) : (
        <>
          {icon && icon}
          {text && text}
        </>
      )}
    </button>
  );
};

export default Button;